// extracted by mini-css-extract-plugin
export var borderRadius = "_6l-4";
export var large = "_6l-3";
export var logoContainer = "_6l-0";
export var nameLogo = "_6l-2";
export var small = "_6l-1";